import { render } from "./ModalHistorial.vue?vue&type=template&id=a386b5a4&scoped=true"
import script from "./ModalHistorial.vue?vue&type=script&lang=js"
export * from "./ModalHistorial.vue?vue&type=script&lang=js"

import "./ModalHistorial.vue?vue&type=style&index=0&id=a386b5a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a386b5a4"]])

export default __exports__